import { Box, Collapse, Flex, Grid, Text } from '@chakra-ui/react'
import { FC, useEffect, useMemo, Fragment } from 'react'

import useKpiStorage from '@hook/kpi/use-storage'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import SelectStore from '@component/Layout/SelectStore'
import TableGrid from '@component/Layout/TableGrid'
import LayoutTools from '@component/Layout/Tools'
import KpiStorageGraphic from '@component/Modules/Kpi/Graphics/KpiStorageGraphic'
import OpenOrCloseChartButton from '@component/Modules/Kpi/Graphics/OpenOrCloseButton'
import KpiModalStorange from '@component/Modules/Kpi/Modal/modalStorange'

import { scalesHeightKpiTable } from '@helper/kpi/sales/scalesHeightKpiTable'
import { disableActionsByDefault } from '@helper/kpi/storage/disableActionsByDefault'
import { disableActionsByDefaultModal } from '@helper/kpi/storage/disableActionsByDefaultModal'
import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const KpiStorage: FC = () => {
  const { hasSessions } = useSessions()
  const { getFilters } = useFilters()
  const { menuToggle } = useLayout()
  const {
    data,
    query,
    params,
    headers,
    actions,
    filters,
    loading,
    filename,
    fetching,
    filtersList,
    tableInteraction,
    defaoutAverageSale,
    getData,
    setQuery,
    setFilters,
    setFilename,
    exportKpiData,
    handleLocalParams,
    clearAllFilters,
    updateIsGraphic,
    exportKpiDataModal,
    handleUpdateParams,

    dataModal,
    isModalOpen,
    headersModal,
    loadingModal,
    actionsModal,
    isModalConfig,
    isLoadingExport,
    kpiModalTableStructure,
    onModalClose,
    onModalChange,
    updateIsModalConfig,

    pagination,
    paginationMain,
    handlePageChange,
    handlePageChangeMain,

    isGraphic,
    daysQuantity,
    graphicValues,
    loadingGraphic,
    isShowContentChart,
    setIsGraphic
  } = useKpiStorage()

  const graphicValues2 = graphicValues || []

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () => scalesHeightKpiTable({ menuToggle, isGraphic, hasSessions }),
    [menuToggle, isGraphic, hasSessions]
  )

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          if (data?.length === 0) {
            getData()
            handleLocalParams()
          }

          getFilters({
            companies: true,
            centerTypes: true,
            centers: true,
            categoryManagers: true,
            productManagers: true,
            worlds: true,
            compactCategories: true,
            categories: true,
            kpiStatus: true,
            abcCurves: true,
            deposits: true,
            providersForDistribution: true,
            closingBase: true,
            subCategories: true
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="KPI Estoque">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
        isDisabled={loading || fetching || data.length === 0}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={fetching}
            onFilter={getData}
            changedValue={defaoutAverageSale}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box
          overflow={
            isShowContentChart && graphicValues2?.length > 0 ? 'auto' : null
          }
          maxH={
            isShowContentChart && graphicValues2?.length > 0
              ? 'calc(100vh - 136px)'
              : null
          }
        >
          <LayoutTools
            title={filename}
            filters={filters}
            actions={actions}
            query={query}
            onClick={exportKpiData}
            onSearchChange={setQuery}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || fetching || data.length === 0}
            disableActionsByDefault={disableActionsByDefault}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                paddingRight={4}
                paddingLeft={3}
                paddingY={1}
              >
                <Text fontSize={14}>
                  Quantidade de Registros: {paginationMain.totalRows}
                </Text>

                {isShowContentChart && graphicValues2.length > 0 && (
                  <OpenOrCloseChartButton
                    openText="Abrir gráficos"
                    closeText="Fechar gráficos"
                    graphicValue={graphicValues2}
                    isGraphic={isGraphic}
                    setIsGraphic={setIsGraphic}
                  />
                )}
              </Flex>

              {isShowContentChart && (
                <Collapse in={true} unmountOnExit={true}>
                  <>
                    {isGraphic && (
                      <>
                        {loadingGraphic ? (
                          <LayoutLoader
                            type="chart"
                            title="Recuperando informações..."
                            message="Aguarde enquanto buscamos os registros no banco de dados"
                          />
                        ) : (
                          <Fragment>
                            {(() => {
                              try {
                                if (
                                  params.empresaSelectIds.length === 0 &&
                                  isGraphic
                                ) {
                                  return (
                                    <SelectStore
                                      type="chart"
                                      title="Filtro necessario!"
                                      message="Adicione filtro empresa para visualizar o gráfico"
                                    />
                                  )
                                } else if (
                                  !graphicValues ||
                                  graphicValues.length === 0
                                ) {
                                  return (
                                    <LayoutEmpty
                                      type="chart"
                                      title="Nada encontrado!"
                                      message="Filtre sua busca ao lado para obter informações"
                                    />
                                  )
                                } else {
                                  return (
                                    <>
                                      <KpiStorageGraphic
                                        data={graphicValues}
                                        daysQuantity={daysQuantity}
                                      />
                                      <Box
                                        paddingBottom={3.5}
                                        boxShadow="inset 0px 1px 5px 2px #dcdcdc"
                                      />
                                    </>
                                  )
                                }
                              } catch (error) {
                                console.error(
                                  'An error occurred while rendering the graphic:',
                                  error
                                )
                                return (
                                  <LayoutEmpty
                                    type="chart"
                                    title="Erro!"
                                    message="Ocorreu um erro ao tentar renderizar o gráfico. Tente novamente mais tarde."
                                  />
                                )
                              }
                            })()}
                          </Fragment>
                        )}{' '}
                      </>
                    )}
                  </>
                </Collapse>
              )}

              <TableGrid
                id="storage-table"
                entity="kpi-storage"
                data={data}
                query={query}
                headers={headers}
                loading={fetching}
                itsSortable={true}
                height={tableHeight}
                actions={tableInteraction}
                updateIsGraphic={updateIsGraphic}
                pagination={paginationMain}
                udatePageChange={handlePageChangeMain}
                isPagedBack={true}
                isPaged={false}
                isOverflowDisabled={true}
              />

              <KpiModalStorange
                id="storage-table-modal"
                entity="kpi-storage-modal"
                data={dataModal}
                isOpen={isModalOpen}
                onClose={onModalClose}
                headers={headersModal}
                query={query}
                onClickExport={exportKpiDataModal}
                onChange={onModalChange}
                itsSortable={true}
                loadingModal={loadingModal}
                actions={actionsModal}
                isModalConfig={isModalConfig}
                updateIsModalConfig={updateIsModalConfig}
                kpiModalTableStructure={kpiModalTableStructure}
                isDisabled={disableActionsByDefaultModal}
                isLoadingExport={isLoadingExport}
                pagination={pagination}
                udatePageChange={handlePageChange}
                isPagedBack={true}
                isPaged={false}
                isExport
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default KpiStorage
